import classNames from "classnames";
import { inject, observer } from "mobx-react";
import { Component } from "react";
import type { ChangeEvent } from "react";

import { type KnownLocale, knownLocaleOptions } from "nvent-web/i18n";
import { UserStore } from "nvent-web/stores/User";
import compose from "nvent-web/utils/compose";

import style from "./LocalePicker.module.scss";

interface LocalePickerOuterProps {
  dark?: boolean;
}

interface LocalePickerInnerProps {
  user: UserStore;
  dark?: boolean;
}

class LocalePicker extends Component<
  LocalePickerInnerProps & LocalePickerOuterProps
> {
  render() {
    const { dark, user } = this.props;
    const locale = user.locale;

    return (
      <select
        className={classNames(style.select, { [style.dark]: dark })}
        value={locale}
        name="locale"
        onChange={this.handleChange}
      >
        {knownLocaleOptions.map(({ key, title }) => (
          <option key={key} value={key}>
            {title}
          </option>
        ))}
      </select>
    );
  }

  private handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const { user } = this.props;
    user.setLocale(e.target.value as KnownLocale);
  };
}

const LocalePickerComponent = compose<LocalePickerOuterProps>(
  inject("user"),
  observer
)(LocalePicker);

LocalePickerComponent.displayName = "LocalePicker";

export default LocalePickerComponent;
